module.exports = __webpack_public_path__ + "static/media/admin-with-cogwheels.686d8b90.svg";